import { useTranslation } from 'react-i18next';

import { desktopTruncateStyle } from '~/styles/utilities.css';

import type { NumberingSeriesType } from '../types';

type Props = {
  type: NumberingSeriesType;
};

export const NumberingSeriesTypeCell = ({ type }: Props) => {
  const { t } = useTranslation(['settings']);

  return <div className={desktopTruncateStyle}>{t(`settings:fields.numberingSeries.type.options.${type}`)}</div>;
};
